export default {
    // 基本文案
    base: {
        // loading页点击提示
        loading_tapTips: '点击龙蛋开始游戏',
        // 活动按钮
        rule_btn: '规则',
        // 下载按钮
        download_btn: '即时下载',
        // 下载提示窗的slogan
        download_slogan:
            '主人，请带上我，到King of Avalon战斗，领取更多奖励吧！',
        // 取消按钮
        cancel_btn: '取消',
        // 关闭按钮
        close_btn: '关闭',
        // 确认按钮
        confirm_btn: '确认',
        // 兑换按钮
        redeem_btn: '兑换',
        // 分享图片
        share_img: '分享图片',
        // 换一只领养
        changeDragon: '换一只领养',
        // 确认领养并且对战
        adoptBattle: '确认领养并对战',
        // 查看战力说明
        score_rule_btn: '查看战力说明',
        // 中奖记录按钮
        record_btn: '中奖记录',
        // 总战力
        totalPower: '总战力',
        // 未兑换战力
        unredeemedPower: '未兑换战力',
        // 积分奖励
        scorePrize: {
            get_gift_one: '领取5W资源', // 奖励文案
            get_gift_two: '领取金色图像', // 奖励文案
            draw: '转盘抽奖' // 奖励文案
        },
        // 好友页标题
        friendTitle: '<span>%{name}</span>与朋友们的对战',
        // loading页slogan
        loadingSlogan: 'Raise a Dragon for<br>the chance to get a Switch!',
        // 暂无好友提示
        friendEmptyTips: '邀请更多好友<span>对战</span>，累积战力抽奖',
        // 暂无好友对战记录
        norecord_tips: `
        <p>现在还没有朋友来访</p>
        <p>点击分享，晒出你的龙，邀请朋友来对战吧！</p>
        `,
        // 请输入名字
        enter_name: '请输入名字',
        // 请输入邮箱
        enter_email: '请输入邮箱',
        // 请输入正确格式邮箱
        enter_right_email: '请输入正确邮箱格式',
        // 请输入国家
        enter_country: '请输入国家',
        // 请输入地址
        enter_address: '请输入地址',
        // 请输入手机号
        enter_phone: '请输入手机号',
        // 请输入正确格式手机号
        enter_rightr_phone: '请输入正确手机号格式',
        // 活动结束
        activityEnd: `<p>活动已结束，活动内所有奖励已经全部抽完，感谢大家的积极参与！
         还有几位领主似乎不敢相信他们有这份幸运，在活动中没有填写个人信息和地址，请前往<a href="https://www.facebook.com/koadw/">King of Avalon Facebook</a>主页确认，我们将会与您取得联系！
         现在下载<a href="https://app.adjust.com/ts8zich_dz016n6">King of Avalon</a>，养一条自己的龙！<p>`
    },
    popup: {
        // 请输入昵称
        inputNameTips: '主人，请输入你的昵称',
        // 生成专属龙
        genDragonTips: '正在为你生成专属的龙，请稍等',
        // 战力不足
        noScoreTips: '战力不足，点击分享，邀请更多好友对战，累积战力抽奖！',
        // 下载提示
        loginTips:
            '请先登录，领养属于<br>自己的龙，对战<br>抽Switch & AirPods Pro！',
        // 分享提示
        shareTips: '邀请更多好友对战，<br>累积战力抽奖',
        // 活动规则
        rule: {
            title: '规则',
            content: `
                <p><h3>1. 活动期限：</h3><p>2021/7/14-2021/7/27<h3></p>
                <p><h3>2. 游戏规则：</h3>
                <p>养龙规则：玩家需要登录Facebook或VK后，才可参与游戏领养龙。每条龙有自己的独特形象、姓名和属性，玩家生成龙后，不可更换</p>
                <p>对战规则：玩家需分享游戏给好友，好友领养自己的龙后，双方自动对战，对战后获得战力。相同两人最多可重复对战3次</p>
                <p>邀请规则：玩家可分享游戏至Facebook/WhatsApp/VK平台，邀请好友参与对战</p>
                <p>战力规则：对战胜利获得300战力，对战失败获得200战力，点击链接下载King of Avalon获得600战力</p>
                </p>
                <p><h3>3. 奖励规则：</h3>
                <p>1）活动期间，达到300战力可领取价值$5的King of Avalon资源礼包；600战力可领取价值$10的King of Avalon资源礼包；1000战力可获得一次抽奖机会，有机会获得有机会获得价值$20的King of Avalon资源礼包、亚马逊$10购物卡、亚马逊$50购物卡、Switch、索尼PS5、AirPods Pro</p>
                <p> 2）资源礼包共10万份，玩家获得礼包码后，下载King of Avalon输入礼包码领取，礼包码有效期3个月，请尽快领取</p>
                <p> 3）亚马逊购物卡共38份，实物奖励共8份，抽得购物卡或实物奖励，需要玩家留下个人信息，工作人员将在活动结束后7个工作日内与玩家联系</p>
                <p> 4）购物卡及实物奖励名单将于2021/7/28公告于《King of Avalon》官方Facebook主页。获奖者需于2021/8/5前回复邮件提供得奖资料，逾期则视为放弃中奖资格</p>
                <p>5）本活动因涉及实体奖励，限在美国、俄罗斯地区玩家参加。部分偏远地区需加收额外运费(区域及实际运费由物流判定)。若因玩家资料填写不完整者，导致无法收到，无法补发奖励。且活动奖项一经寄出后，若于运送途中或运送至中奖人指定收件地址后发生遗失、冒领或被窃等丧失占有之情形，概由中奖人自行负责，本公司均不负补发奖项之责任 </p>
                <p>4. 此次活动最终解释权归FunPlus所有。参加本活动者均了解及接受主办单位所订定之活动办法及游戏规则，若违反相关规定、恶意破坏游戏秩序或影响他人之情事，经查证属实者，本公司有权取消该参加者的任何权利及活动资格。</p>
            `
        },
        // 战力说明
        powerInfo: {
            title: '查看战力说明',
            content: `
                <p>1. 对战胜利获得300战力，对战失败获得200战力，点击链接下载King of Avalon获得600战力</p>
                <p>2. 300战力可领取价值$5的King of Avalon资源礼包；600战力可领取价值$10的King of Avalon资源礼包；1000战力可获得一次抽奖机会，有机会获得有机会获得价值$20的King of Avalon资源礼包、亚马逊$10购物卡、亚马逊$50购物卡、Switch、索尼PS5、AirPods Pro</p>
                <p>3. 300/600阶段奖励仅能领取一次。抽奖可抽多次，单次抽奖后扣除1000积分，并重新开始累积战力</p>
                <p>4. 总战力越高，获胜幸运值越高。已兑换战力不影响获胜幸运值</p>
                <p>5. 相同两人最多可重复对战3次</p>
            `
        },
        // 兑换码弹窗
        code: {
            title: `恭喜您获得
            【%{reward}】`,
            label: '兑换码',
            // 一键复制按钮
            copy_btn: '一键复制',
            // 跳转兑换按钮
            redeem_btn: '跳转兑换',
            // 复制礼包码成功
            copy_success: '复制礼包码成功'
        },
        // 购物卡
        giftCard: {
            title: '恭喜您获得<br>【%{reward}】',
            desc:
                '请留下联系方式，工作人员将在<br />活动结束后7个工作日内与您联系',
            name: '姓名',
            country: '国家',
            email: '邮箱'
        },
        // 实物奖
        entity: {
            title: '恭喜您获得<br>【%{reward}】',
            desc:
                '请留下联系方式，工作人员将在<br />活动结束后7个工作日内与您联系”',
            name: '姓名',
            addr: '收件<br>地址',
            mobile: '电话',
            email: '邮箱'
        },
        draw: {
            // 中奖资料填写成功
            fillSucc: '成功提交，工作人员将在活动结束后7个工作日内与您联系',
            free: '恭喜您完成第一次对战<br>获得一次免费抽奖机会',
            // 未中奖文案
            noReward: `很遗憾您未中奖，邀请更多好友对战，累积战力抽奖！`
        },
        // 好友页
        friend: {
            name: 'Name',
            battles: 'Battles',
            power: 'Power',
            battleAgain: 'Battle<br>Again'
        },
        // 中奖记录
        record: {
            title: '中奖记录',
            record_time: '中奖时间',
            record_name: '获得奖品'
        }
    },
    game: {
        slogan: [
            '来和我对战吧！',
            '想和我PK吗？',
            '我超强！',
            '带我去战斗！',
            '把我分享给好友，才能对决哦',
            '点我和我说话吧',
            '快让我去战斗吧！',
            '主人现在心情怎么样？',
            '主人爱听什么歌？',
            '主人，你知道撒哈拉之眼在哪里吗？',
            '我最想去的地方是冰岛，主人你呢？',
            '不要忘记戴口罩哦',
            '我好想吃大汉堡哦！主人你呢？',
            '主人，你觉得我要减肥吗？',
            '啊呜啊呜啊呜',
            'Wubba lubba dub dub',
            '好运总是会来的',
            '早睡能解决99%的人生烦恼',
            '那些让你烦恼的事，都没什么大不了',
            '别想啦，谁能把这个世界想明白呢？',
            '我想变成一头真正的龙，能喷火的那种！',
            '主人你玩不玩游戏呀？听说King of Avalon里有我的龙兄弟',
            '莫甘娜，这次我一定不放过你！',
            '听说下载游戏我能获得更多战力，获胜几率会提高哦！'
        ]
    },
    msg: {
        // pk次数限制文案
        pklimit: '相同好友最多对战3次，邀请更多好友对战，累积战力抽奖！',
        // 长按保存相片提示
        pressimg2savepicture: '长按保存图片',
        // 等待文案
        waiting: 'loading...'
    }
};
